import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import useNetwork from 'hooks/use-network';
import NetworkIcon from 'images/network_wrong.png';
import { useWrongNetworkPopup } from 'store';

const usePopupStyles = makeStyles((theme) => ({
  sendDialog: {
    position: 'fixed',
    top: '48px',
    left: '0',
    right: '0',
    margin: '0 auto',
    display: 'flex',
    maxWidth: '595px',
    padding: '16px 24px',
    alignItems: 'center',
    borderRadius: '20px',
    border: '1px solid #323235',
    background: '#292A2F',
    zIndex: 1400,
    boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.40)',
    [theme.breakpoints.down('xs')]: {
      margin: '16px 8px',
      padding: '16px 16px',
      flexDirection: 'column',
      gap: 16,
    },
  },
  sendDialogBig: {
    maxWidth: '650px',
  },
  dialogContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '32px',
    '& p': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '24px',
      whiteSpace: 'pre-line',
    },
  },
  btn: {
    display: 'flex',
    width: '153px',
    height: '48px',
    padding: '13px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
    flexShrink: 0,
    borderRadius: '6px',
    background: 'var(--dark-neutral-stroke, rgba(255, 255, 255, 0.10))',
    cursor: 'pointer',
  },
  txtContent: {
    display: 'flex',
    flexDirection: 'column',
    '& > p': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '32px',
      whiteSpace: 'pre-line',
      color: '#FAFAFA',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: '24px',
      },
    },
    '& > span': {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '20px',
      color: '#ABABAB',
    },
  },
}));

interface WrongNetworkPopupProps {
  onClose?: () => void;
}

export const WrongNetworkPopup: React.FC<WrongNetworkPopupProps> = ({ onClose }) => {
  const classes = usePopupStyles();
  const [network, , setNetwork] = useNetwork();

  const { wrongNetworkPopupShown, hideWrongNetworkPopup, wrongNetworkPopupOptions } =
    useWrongNetworkPopup();

  const changeNetwork = () => {
    network === 'mainnet' ? setNetwork('testnet') : setNetwork('mainnet');
  };

  const handleClose = () => {
    hideWrongNetworkPopup();
    onClose?.();
  };

  useEffect(() => {
    if (wrongNetworkPopupShown && wrongNetworkPopupOptions.autoHide) {
      const timerId = setTimeout(() => {
        handleClose();
      }, 3200);

      return () => clearTimeout(timerId);
    }
  }, [wrongNetworkPopupShown]);

  // TODO: add close button
  // TODO: replace with dialog or snackbar notification
  return (
    <>
      {wrongNetworkPopupShown && (
        <div className={classNames(classes.sendDialog, classes.sendDialogBig)}>
          <div className={classes.dialogContent}>
            <img width="50px" src={NetworkIcon} alt="" />
            <div>
              <div className={classes.txtContent}>
                <p>Wrong network</p>
                <span>
                  {wrongNetworkPopupOptions.text ||
                    'Networks of the connected wallet and Asigna do not match'}
                </span>
              </div>
            </div>
          </div>
          {!wrongNetworkPopupOptions.noButton && (
            <div>
              <div
                className={classes.btn}
                onClick={() => {
                  handleClose();
                  changeNetwork();
                }}
              >
                Switch to {network === 'mainnet' ? 'Testnet' : 'Mainnet'}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
